<div class="card">
  <app-header titulo="Funções" descricao=""></app-header>

  <a [routerLink]="['novo']"><button pButton icon="pi pi-plus" label="Nova Função"></button></a>

  <div class="mt-3">
    <p-table [value]="funcoes" dataKey="id" editMode="row" >
      <ng-template pTemplate="header">
        <tr>
          <th>Nome</th>
          <th>Descricao</th>
          <th>Módulo</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-funcao>
        <tr>
          <td>{{ funcao.nome }}</td>
          <td>{{ funcao.descricao }}</td>
          <td>{{ funcao.nomeModulo }}</td>
          <td>
            <a [routerLink]="['editar', funcao.id]"><p-button
              icon="pi pi-pencil"
              [rounded]="true"
              [text]="true"
              severity="info"

              aria-label="Editar"
            ></p-button></a>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
